import Select from "react-select";
import styled from "styled-components";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { RootState } from "../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { fieldErrorMessage, fieldHasErrors } from "../../store/errorHandler";
import { getSelectedStatusOption, STATUS_OPTIONS, Option, allowSave, allowDelete } from "../../store/helpers";
import { createJenisDokumenAsync, getDetailJenisDokumenAsync, getJenisDokumenAsync, initializeCreateJenisDokumen, updateJenisDokumenAsync, updateKode, updateName, updateParent, updateStatus } from "../../reducers/jenisDokumen/jenisDokumen.actions";
import { PermissionMenuName } from "../../interfaces/UserRole";

export const JenisDokumenUpdatePage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isNew, setIsNew] = useState<boolean>(false);
  const errors = useSelector((state: RootState) => state.jenisDokumen.error);
  const [jenisDokumenOptions, setJenisDokumenOptions] = useState<Option[]>([]);
  const isLoading = useSelector((state: RootState) => state.jenisDokumen.isLoading);
  const redirectQueue = useSelector((state: RootState) => state.jenisDokumen.redirectQueue);
  const jenisDokumen = useSelector((state: RootState) => state.jenisDokumen.selectedJenisDokumen);
  const listJenisDokumen = useSelector((state: RootState) => state.jenisDokumen.listJenisDokumen);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.masterData].ACCESS);

  const canSave = allowSave(role, 2);
  
  useEffect(() => {
    const paths = location.pathname.split("/");
    if (paths[2] === 'create') {
      setIsNew(true);
      dispatch(initializeCreateJenisDokumen());
    } else {
      setIsNew(false);
      const id = parseInt(paths[2]);
      if (id && !isNaN(id)) {
        dispatch(getDetailJenisDokumenAsync.request({ id }));
      } else {
        history.push(`/jenis-dokumen/create`);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (redirectQueue) {
      history.push(redirectQueue);
      dispatch(initializeCreateJenisDokumen());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectQueue])

  useEffect(() => {
    dispatch(getJenisDokumenAsync.request({}));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateName(e.target.value));
  }

   const onChangeKode = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateKode(e.target.value));
  }

  const onChangeStatus = (e: Option | null) => {
    if (!e) return;
    if (isNaN(parseInt(e.value))) return;
    dispatch(updateStatus(parseInt(e.value)));
  }

  const save = () => {
    if (!jenisDokumen) return;
    if (isNew) {
      dispatch(createJenisDokumenAsync.request(jenisDokumen))
    } else {
      dispatch(updateJenisDokumenAsync.request(jenisDokumen))
    }
  }

  const getSelectedJenisDokumenOption = () => {
    const empty = { value: '-1', label: 'Tidak ada' };
    if (!jenisDokumen || !jenisDokumen.DOK_JENIS_PARENT || !jenisDokumen.DOK_JENIS_PARENT_DETAIL) return empty;
    const selection = jenisDokumen.DOK_JENIS_PARENT_DETAIL;
    if (selection) {
      return { value: selection.DOK_JENIS_ID.toString(), label: selection.DOK_JENIS_NAMA };
    }
    return empty;
  }

  const onChangeJenisDokumen = (e: Option | null) => {
    if (!e) return;
    const id = parseInt(e.value);
    if (isNaN(id)) return;
    if (id === -1) {
      dispatch(updateParent(null, null));
    } else {
      const newJenisDokumen = listJenisDokumen.find(search => search.DOK_JENIS_ID === id);
      if (newJenisDokumen) { dispatch(updateParent(id, newJenisDokumen)); }
    }
  }
  
  useEffect(() => {
    let options: Option[] = [];
    options = listJenisDokumen.map(item => {
      return {
        value: item.DOK_JENIS_ID.toString(),
        label: item.DOK_JENIS_NAMA
      };
    });
    const newOptions = [
      {
        value: '-1',
        label: 'Tidak ada'
      },
      ...options
    ]
    setJenisDokumenOptions(newOptions);
  }, [listJenisDokumen]);
 
  return (
    <JenisDokumenUpdatePageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-5">
            <div className="box">
              <div className="box-header with-border">
                <h3 className="box-title">Detail Jenis Dokumen</h3>
                <div className="box-tools">
                  <button
                    className="btn btn-primary"
                    style={{marginRight: '4px'}}
                    onClick={() => history.push('/jenis-dokumen')}
                  >
                    kembali
                  </button>
                  <button
                    className="btn btn-primary"
                    disabled={isLoading || !canSave}
                    onClick={save}
                  >
                    Simpan
                  </button>
                </div>
              </div>
              <div className="box-body">
                <div className={`form-group ${fieldHasErrors('DOK_JENIS_NAMA', errors) ? 'has-error' : ''}`}>
                  <label>Nama Jenis Dokumen <span className="text-red"><b>*</b></span></label>
                  <input
                    className='form-control'
                    style={{ display: 'block', width: '100%' }}
                    defaultValue={jenisDokumen?.DOK_JENIS_NAMA}
                    onChange={onChangeName}
                    disabled={isLoading || !canSave}
                    type="text"
                  />
                  <span className="help-block">{ fieldErrorMessage('DOK_JENIS_NAMA', errors) }</span>
                </div>
                <div className={`form-group ${fieldHasErrors('DOK_JENIS_KODE', errors) ? 'has-error' : ''}`}>
                  <label>Kode <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    onChange={onChangeKode}
                    className='form-control'
                    disabled={isLoading || !canSave}
                    style={{ display: 'block', width: '100%' }}
                    defaultValue={jenisDokumen?.DOK_JENIS_KODE}
                  />
                  <span className="help-block">{ fieldErrorMessage('DOK_JENIS_KODE', errors) }</span>
                </div>
                <div className="form-group">
                  <label>Status</label>
                  <Select 
                    options={STATUS_OPTIONS}
                    onChange={onChangeStatus}
                    value={getSelectedStatusOption(jenisDokumen?.STATUS)}
                    isDisabled={isLoading || !allowDelete(role, 2)}
                  />
                </div>
                <div className="form-group">
                  <label>Induk</label>
                  <Select
                    options={jenisDokumenOptions}
                    onChange={onChangeJenisDokumen}
                    isDisabled={isLoading || !canSave}
                    value={getSelectedJenisDokumenOption()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </JenisDokumenUpdatePageWrapper>
  );
}

const JenisDokumenUpdatePageWrapper = styled.div``;